import React, { Component } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  Media
} from "reactstrap";
import axios from "axios";
import { joinCss, StrIsEmailValidation, isNullOrEmpty } from "../helpers/utils";
import _ from "lodash";
import ReCAPTCHA from "react-google-recaptcha";

import appClasses from "../App.module.scss";
import classes from "./MailingListSubscrib.module.scss";

import background from "../images/mailingListBackground.png";

class MailingListSubscrib extends Component {
  constructor(props) {
    super(props);
    this.state = {
      captchaSuccess: false,
      captchaClass: "",
      fullName: "",
      companyName: "",
      email: "",
      fullNameValidated: true,
      emailValidated: true,
      userMessage: "",
      errorMessage: false
    };

    this.recaptchaRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.subscrib = this.subscrib.bind(this);

    this.validateFullName = this.validateFullName.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.captchaChange = this.captchaChange.bind(this);
  }
  captchaChange() {
    this.setState({ captchaSuccess: true });
    this.setState({ captchaClass: "" });
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  subscrib() {
    let that = this;
    this.allowEmptyValidation = false;
    this.validateAllFields(false);
    if (!this.state.captchaSuccess) {
      this.setState({ captchaClass: appClasses["validation-error"] });
    }
    if (
      this.state.fullNameValidated &&
      this.state.emailValidated &&
      this.state.captchaSuccess
    ) {
      console.log("subscrib...");
      axios
        .post("api/files/addToMailingList", {
          fullName: this.state.fullName,
          email: this.state.email,
          companyName: this.state.companyName
        })
        .then(function(response) {
          if (response.status == "200") {
            that.setState({
              captchaSuccess: false,
              captchaClass: "",
              userMessage: "הרשמתך התקבלה.",
              errorMessage: false,
              fullName: "",
              email: "",
              companyName: "",
              fullNameValidated: true,
              emailValidated: true
            });
            that.recaptchaRef.current.reset();
          } else {
            that.setState({
              userMessage: "הרשמתך נכשלה אנא נסה שוב.",
              errorMessage: true
            });
          }
        });
    } else {
      console.log("validation error...");
    }
  }

  validateFullName(allowEmpty) {
    console.log("validateFullName...");
    this.state.fullNameValidated = false; //reset first , before check
    //required
    this.state.fullNameValidated =
      !isNullOrEmpty(this.state.fullName) || allowEmpty;
  }

  validateEmail(allowEmpty) {
    console.log("validateEmail...");
    this.state.emailValidated = false;

    //required
    if (!isNullOrEmpty(this.state.email)) {
      this.state.emailValidated = StrIsEmailValidation(this.state.email);
    } else if (allowEmpty) {
      this.state.emailValidated = true;
    }
  }

  allowEmptyValidation = true; //onload
  validateAllFields(allowEmpty) {
    this.allowEmptyValidation = false;
    try {
      this.validateFullName(allowEmpty);
      this.validateEmail(allowEmpty);
    } catch (err) {
      console.log(err);
    }
    this.forceUpdate(); //force render , don't call this from render() / componentDidUpdate()
  }

  //get from cache on re-render
  // 2nd: resolver func to use more args after args[0]
  _resolver_ = (...args) => args.join(".");

  _validateFullName = _.memoize(this.validateFullName, this._resolver_);
  _validateEmail = _.memoize(this.validateEmail, this._resolver_);

  render() {
    const validationErrorClass = appClasses["validation-error"];

    this._validateFullName(this.allowEmptyValidation, this.state.fullName);
    const VfullName = this.state.fullNameValidated ? "" : validationErrorClass;
    this._validateEmail(this.allowEmptyValidation, this.state.email);
    const Vemail = this.state.emailValidated ? "" : validationErrorClass;
    const vrecaptcha = this.state.captchaClass;

    return (
      <Container id="mailingListSubscrib">
        <Row>
          <Col className={joinCss("px-0", classes.mailingListSubscricImgCol)}>
            <Media
              src={background}
              alt="רשימת תפוצה"
              className={classes.mailingListSubscricImg}
            />
            <Container className={classes.fieldsContainer}>
              <Row>
                <Col className={classes.mailingListHeader}>
                  הרשמו לרשימת התפוצה שלנו!
                </Col>
              </Row>
              <Row>
                <Col className={classes.mailingListSubHeader}>
                  ואנחנו נעדכן אתכם בזמן אמת
                </Col>
              </Row>
              <Form>
                <FormGroup row className="mx-5">
                  {/* {classes.formRow} */}
                  <Col lg="4" md="6" className={classes.fieldCol}>
                    <Input
                      aria-label="שם מלא"
                      type="input"
                      name="fullName"
                      id="fullName"
                      placeholder="שם מלא"
                      className={VfullName}
                      value={this.state.fullName}
                      onChange={this.handleChange}
                    />
                  </Col>
                  <Col lg="4" md="6" className={classes.fieldCol}>
                    <Input
                      aria-label="כתובת דואל"
                      type="input"
                      name="email"
                      id="email"
                      placeholder="כתובת דואל"
                      className={Vemail}
                      value={this.state.email}
                      onChange={this.handleChange}
                    />
                  </Col>
                  <Col lg="4" md="6" className={classes.fieldCol}>
                    <Input
                      aria-label="חברה (רשות)"
                      type="input"
                      name="companyName"
                      id="companyName"
                      placeholder="חברה (רשות)"
                      value={this.state.companyName}
                      onChange={this.handleChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row className="mx-5">
                  {/* {classes.formRow} */}
                  <Col
                    xl="4"
                    lg="8"
                    md="8"
                    className={joinCss(classes.fieldCol, vrecaptcha)}
                  >
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      sitekey="6LdqpMYUAAAAAOnLPlnZrhXPfYNBxNyT8UonLDLN"
                      onChange={this.captchaChange}
                      hl="iw"
                    />
                  </Col>
                  <Col xl="4" lg="4" md="4" className={classes.fieldCol}>
                    <Button
                      className={classes.subscribButton}
                      onClick={() => this.subscrib()}
                    >
                      שלח
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
              <Row>
                <Col
                  className={
                    this.state.errorMessage
                      ? classes.errorMessage
                      : classes.mailingListSubHeader
                  }
                >
                  {this.state.userMessage}
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MailingListSubscrib;
